<template>
    <div class="stepNineRoot">
      <div class="backPageItem"><BackPageVue  @backPreviewPage="hanldGoBack"></BackPageVue> </div>

      <div class="fourBox">
          <div class="btnLine">
              <div class="leftBtn"  @click="changeBuyMethod(1)" :style="{background:buyMethod===1?'#212121':'#EEE',color:buyMethod===1?'#FAFAFA':'#757575',fontWeight:buyMethod===1?600:400}">
                  <span class="leftBtnText">{{$t('mainModule.autoBtn')}}</span> 
                  <span class="offBtn">10%OFF</span>
              </div>
              <div class="rightBtn" @click="changeBuyMethod(2)"  :style="{background:buyMethod===2?'#212121':'#EEE',color:buyMethod===2?'#FAFAFA':'#757575',fontWeight:buyMethod===2?600:400}">{{$t('mainModule.permonthBtn')}}</div>
          </div>
          <div class="formLine">
              <ChargeBlock  :currentStatus="buyMethod" @confirmPay="handleClickPaymment" toLink="/register"></ChargeBlock>
          </div>
          

          <div class="lastBtnLine">
            <div class="subBtn" @click.stop="goToRegister">Create Account</div>
        </div>
      </div>
      
    </div>
</template>
<script>
import ChargeBlock from '../common/chargeBlock.vue'
import BackPageVue from './backPage.vue'

export default {
    components:{ChargeBlock,BackPageVue},
    data(){
      return{
        imgObj:{
          guideHomebg1:require("../../assets/img/main/guideHomebg1.png"),
          guideHomebg2:require("../../assets/img/main/guideHomebg2.png"),
        },
        buyMethod:1,
       
      }
  },
  methods:{
    hanldGoBack(){
        console.log(4444)
      localStorage.setItem('guideIndex', 7);
      this.$emit('changePage', 7);
    },

    goToRegister(){
      localStorage.setItem('guideIndex', 20);
      this.$emit('changePage', 20);
      if(this.$route.path !== '/register'){
        this.$router.push('/register'); // 如果使用了路径
      }
    },
    goToNextStep(index){
      localStorage.setItem('guideIndex', 8);
      this.$emit('changePage', 8);

    },
    changeBuyMethod(index){
            this.buyMethod = index
        },
    //点击支付按钮
    handleClickPaymment(){
        this.goToRegister()
        // this.paymentDialogVisible = true
    
    },
  }
}
</script>

<style lang="scss">
.stepNineRoot{
    width: 100%;
    min-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .backPageItem{
      position: absolute;
      z-index: 999;
      left: 100px;
      top:40px;
      width: 30px;
      height: 30px;
    }
    .lastBtnLine{
            position: absolute;
            left: 0;
            bottom: 40px;
            display: inline-block;
            gap: 12px;
        .subBtn{
            cursor: pointer;
            display: flex;
            box-sizing: border-box;
            padding: 6px 17px;
            // width: 80px;
            justify-content: center;
            align-items: center;
            border-radius: var(--8, 8px);
            background:  #FEAE00;
            color:  #212121;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
        }
        .subBtn:hover{
            background: #f69f04;
        }
        .subBtn:active{
            background: #f69f04;
        }
        .defBtn{
            cursor: pointer;
            display: flex;
            box-sizing: border-box;
            border: 1px solid #000;
            padding: 5px 16px;
            // width: 80px;
            justify-content: center;
            align-items: center;
            border-radius: var(--8, 8px);
            background:  #fff;
            color:  #000;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
        }
    }
  .fourBox{
                display: flex;
                width: 80%;
                max-width:1000px;
                min-width:900px;
                padding: 40px 0;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 60px;
                position: relative;
                .btnLine{
                    display: flex;
                    // width: 427px;
                    height: 60px;
                    padding: 4px;
                    align-items: flex-start;
                    gap: 4px;
                    border-radius: var(--16, 16px);
                    background: var(--Grey-Grey-200, #EEE);
                    .leftBtn{
                        // width: 227px;
                        white-space: nowrap;
                        cursor: pointer;
                        display: flex;
                        padding: 6px 24px;
                        justify-content: center;
                        align-items: center;
                        gap: 10px;
                        flex: 1 0 0;
                        align-self: stretch;
                        border-radius: 13px;
                        background: var(--Grey-Grey-900, #212121);
                        color: var(--Grey-Grey-50, #FAFAFA);
                        text-align: center;
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 24px; /* 120% */
                        .leftBtnText{
                            font-family: PingFang SC !important;
                        }
                        .offBtn{
                            display: flex;
                            padding: 2px 8px;
                            justify-content: center;
                            align-items: center;
                            gap: 8px;
                            border-radius: var(--8, 8px);
                            background: var(--Orange-A-Orange-A400, #FF6D00);

                            color: var(--text-icon-font-wh-190-anti, rgba(255, 255, 255, 0.90));
                            text-align: center;
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 600;
                            line-height: 20px;  
                            font-family: PingFang SC !important;
                        }
                    }
                    .rightBtn{
                        white-space: nowrap;
                        cursor: pointer;
                        display: flex;
                        padding: 6px 24px;
                        justify-content: center;
                        align-items: center;
                        gap: 4px;
                        flex: 1 0 0;
                        align-self: stretch;
                        border-radius: 13px;
                        background: var(--Grey-Grey-200, #EEE);
                        color: var(--Grey-Grey-600, #757575);
                        text-align: center;
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px; /* 120% */
                        font-family: PingFang SC !important;
                    }
                }
                .formLine{
                    width: 100%;
                    overflow-x: auto;
                    table{
                        width: 100%;
                        display: flex;
                    }
                }
                .payLine{
                    width: 100%;
                    padding: 0  ; 
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;
                    align-items: center;
                    justify-content: center;
                    // flex-wrap: wrap;
                    .payItem{
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        .payIcon{
                            width: 20px;
                            height: auto;
                        }
                        .payText{
                            color: #212121;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 400;
                            font-family: PingFang SC !important;
                        }
                    }
                }
                .textLine{
                    width: 100%;
                    padding: 0 10vw;
                    .textItem{
                        color: #212121;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 25px; /* 178.571% */
                        font-family: PingFang SC !important;
                    }
                }
            }
}
@media screen and (max-width:767px) { 
  .stepNineRoot{
    .backPageItem{
      position: absolute;
      left: 2vw;
      top:3vw;
      width: 4vw;
      height: 4vw;
    }
    .lastBtnLine{
        position: absolute;
            left: 0;
            bottom: 10vw;
            display: inline-block;
      .subBtn{
          cursor: pointer;
          display: flex;
          box-sizing: border-box;
          padding: 1.4vw 2vw;
          // width: 80px;
          justify-content: center;
          align-items: center;
          border-radius: var(--8, 8px);
        //   background:  #000;
        //   color:  #fff;
          text-align: center;
          font-size: 3.4vw;
          font-style: normal;
          font-weight: 400;
          line-height:1.4;
      }
      .defBtn{
          cursor: pointer;
          display: flex;
          box-sizing: border-box;
          border: 1px solid #000;
          padding:1.4vw 2vw;
          // width: 80px;
          justify-content: center;
          align-items: center;
          border-radius: var(--8, 8px);
          background:  #fff;
          color:  #000;
          text-align: center;
          font-size: 3.4vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.4vw;
      }
    }
    .fourBox{
        width:95%;
        min-width: auto;
        gap: 5.5vw;
        padding: 10vw 0;
        border-bottom: 1px solid #F5F5F5;
        .btnLine{
            height:7vw;
            padding:0.3vw ;
            gap:0.3vw;
            width: 90%;
            box-sizing: border-box;
            .leftBtn{
                padding:1vw 2vw 1vw 3vw;
                font-size: 3vw;
                gap:1vw;
                line-height: 2;
                border-radius:2vw;
                .offBtn{
                    padding: 0.6vw 0.8vw;
                    gap: 0.6vw;
                    font-size: 2vw;
                    line-height: 1.4;
                }
            }
            .rightBtn{
                border-radius:2vw;
                padding:1vw 3vw;
                font-size: 3vw;
                gap:1vw;
                line-height: 2;
            }
        }
        .payLine{
            padding: 0 5vw ; 
            gap: 2vw;
            flex-wrap: wrap;
            justify-content: center;
            .payItem{
                gap: 1vw;
                .payIcon{
                    width: 3vw;
                }
                .payText{
                    font-size: 3vw;
                }
            }
        }
        .textLine{
            padding: 0  5vw;
            .textItem{
                font-size: 3vw;
                line-height: 2; 
            }
        }
    }
  }
}


@media screen  and (min-width: 767px) and (max-width: 1200px){
  .stepNineRoot{
    .backPageItem{
      position: absolute;
      left: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .lastBtnLine{
        position: absolute;
            left: 0;
            bottom: 4vw;
            display: inline-block;
      .subBtn{
          cursor: pointer;
          display: flex;
          box-sizing: border-box;
          padding: 0.52vw 1.62vw;
          // width: 80px;
          justify-content: center;
          align-items: center;
          border-radius: var(--8, 8px);
        //   background:  #000;
        //   color:  #fff;
          text-align: center;
          font-size: 1.4vw;
          font-style: normal;
          font-weight: 400;
          line-height: 2.2vw;
      }
      .defBtn{
          cursor: pointer;
          display: flex;
          box-sizing: border-box;
          border: 1px solid #000;
          padding:0.5vw 1.6vw;
          // width: 80px;
          justify-content: center;
          align-items: center;
          border-radius: var(--8, 8px);
          background:  #fff;
          color:  #000;
          text-align: center;
          font-size: 1.4vw;
          font-style: normal;
          font-weight: 400;
          line-height: 2.2vw;
      }
    }
    .fourBox{
        width:90%;
        min-width: auto;
        gap: 5.5vw;
        padding: 4vw 0;
        .btnLine{
            height:5.6vw;
            padding:0.3vw;
            gap:0.3vw;
            .leftBtn{
                border-radius:1.4vw;
                padding:0.2vw 2.2vw;
                font-size: 1.8vw;
                gap:1vw;
                line-height: 2;
                .offBtn{
                    padding: 0.2vw 0.6vw;
                    gap: 0.6vw;
                    font-size: 1vw;
                    line-height: 2;
                }
            }
            .rightBtn{
                border-radius:1.4vw;
                padding:0.2vw 2.2vw;
                font-size: 1.8vw;
                gap:1vw;
                line-height: 2;
            }
        }
        .payLine{
            padding: 0 4vw 0 10vw;
            gap: 1.2vw;
            .payItem{
                gap: 0.4vw;
                .payIcon{
                    width: 2vw;
                    height: auto;
                }
                .payText{
                    font-size: 1.2vw;
                }
            }
        }
        .textLine{
            .textItem{
                font-size: 1.1vw;
                line-height: 1.6; /* 178.571% */
            }
        }
    }
  }
}
</style>